import { FC } from 'react';

import MesUiGlobalFooter from '@mes-ui/global-footer';
import { Box } from '@mui/material';
import { useAppSelector, useSPOStudent } from 'hooks';
import { configSelector } from 'selectors';

import '@mes-ui/global-footer/styles/index.css';

const GlobalFooter: FC = () => {
  const config = useAppSelector(configSelector);
  const isSpoStudent = useSPOStudent();

  return (
    <Box
      className="global-footer-container"
      sx={{
        // удаление ненужных стилей с футера
        '& > *': {
          border: 'none',
        },
        '& > * > *': {
          paddingInline: 'unset',
          background: 'transparent',
        },
      }}
    >
      <MesUiGlobalFooter version={config?.VERSION} eduType={isSpoStudent ? 'SPO' : undefined} />
    </Box>
  );
};

export default GlobalFooter;
